import { Directive, Input, Output, EventEmitter } from '@angular/core';
import moment from 'moment';
import { TimeParserService } from 'src/app/core/services/time-parser.service';
import { cloneDeep } from 'lodash';

@Directive({
  selector: '[apptimeValidateFormat]',
  host: {
    '(blur)': 'formatTime($event.target.value)',
    '(keyup)': 'validate($event.target.value)',
  },
})

export class TimeValidateDirective {
  @Input('cell') cell: string;
  @Input('apptimeValidateFormat') timeValidate: string;
  @Input('isTimeValid') isTimeValid: boolean;
  @Input('value') time: string;
  @Input('is24') is24: boolean;
  @Output() isTimeValidChange = new EventEmitter<boolean>();
  @Output() valueChange = new EventEmitter<string>();
  timeStr: any
  timeOfDay: string

  constructor(private timeParserService: TimeParserService) {
  }

  validate(value: string) {
    this.timeStr = value;
    var isTimeEmpty = this.timeStr == '' || this.timeStr == null;
    if (!isTimeEmpty) {
      this.isTimeValid = this.parseTime() != null
    }
    //var validateIndex = this.timeValidate;
    //var validationKey = 'time_' + validateIndex;
    this.isTimeValidChange.emit(this.isTimeValid);
  }

  parseTime() {
    this.timeStr = this.timeStr.trim().replace(" ", "");
    var timeOfDay = this.timeStr.toUpperCase().indexOf('A') != -1
      ? 'AM'
      : this.timeStr.toUpperCase().indexOf('P') != -1
        ? 'PM' : null;
    //detect non-colon time
    if (timeOfDay == null && this.timeStr.trim().length > 2 && this.timeStr.indexOf(":") == -1) {
      this.timeStr = this.timeStr.slice(0, this.timeStr.length - 2) + ":" + this.timeStr.slice(this.timeStr.length - 2);
    }
    else if (this.timeStr.length > 4 && this.timeStr.indexOf(":") == -1) {
      var tempTimeStr = this.timeStr.toLowerCase();
      tempTimeStr = tempTimeStr.replace(" ", "").replace("am", "").replace("pm", "").trim();
      tempTimeStr = tempTimeStr.slice(0, tempTimeStr.length - 2) + ":" + tempTimeStr.slice(tempTimeStr.length - 2);
      this.timeStr = tempTimeStr + " " + timeOfDay;
    }
    return this.timeParserService.parseTime(this.timeStr);
  }

  formatTime(value: any) {
    if (value != null && value != "") {
      this.timeStr = value;
      var oldTimeStr = cloneDeep(this.timeStr);
      var timeObj = this.parseTime()
      if (timeObj != null) {
        if (this.timeOfDay == null) {
          if ('StartTime' == this.cell) {
            //hours format
            if (this.timeStr >= 1 && this.timeStr <= 5) {
              timeObj.addHours(12);
            }
            //colon format
            var tempTimeStr = this.timeStr.replace(":", "");
            if (tempTimeStr >= 100 && tempTimeStr <= 559) {
              timeObj.addHours(12);
            }
          }
          else if ('StopTime' == this.cell) {
            //hours format
            if (this.timeStr >= 1 && this.timeStr <= 8) {
              timeObj.addHours(12);
            }
            //colon format
            var tempTimeStr = this.timeStr.replace(":", "");
            if (tempTimeStr >= 100 && tempTimeStr <= 859) {
              timeObj.addHours(12);
            }
          }
        }
      }
      var newTimeStr = moment(timeObj).format((this.is24 ? 'HH:mm' : 'hh:mm A'));
      if (oldTimeStr != newTimeStr) {
        this.valueChange.emit(newTimeStr);
      }
    }
  }
}